import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { StateService } from "../../services/state.service";
import { HttpService } from "../../services/http.service";
import { MessageService } from "primeng/api";

export interface VILCOpportunity {
  sku: string;
  sku_detail: string;
  ptc_segment: number;
  brand: string;
  maco_hl: number;
  maco_hl_threshold: number;
  maco_hl_segment: number;
  vilc_hl: number;
  vilc_index: number;
  volume: number;
  financially_viable: boolean | null;
  have_new_value: boolean | null;
  new_vilc_hl?: number | null;
}

@Component({
  selector: "app-vilc-opportunities",
  templateUrl: "./vilc-opportunities.component.html",
  styleUrls: ["./vilc-opportunities.component.scss"],
})
export class VILCOpportunitiesComponent implements OnInit, OnChanges {
  @Input() opportunities: VILCOpportunity[] = [];
  @Input() expId: string = "";
  @Output() actionButtonCall = new EventEmitter<any>();
  @Output() refreshVilcOpportunities = new EventEmitter<any>();
  rows: VILCOpportunity[] = [];
  formMap: Record<number, FormGroup> = {};
  pageSizes: number[] = [5, 10, 20, 50];
  pageSize: number = 5;
  currentPage: number = 1;
  totalItems: number = 0;
  showVilcGuideDialog: boolean = true;
  showModifyDialog: boolean = false;
  currentStep = 1;
  allowedFileType: any = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
    "text/csv",
  ];
  fileUploadContent: any = {
    title: "",
    fileName: "",
    fileSize: "",
    fileUploadPercent: 0,
    fileUploadStatus: false,
    disableFlag: false,
    loaderFlag: false,
    allowedFileType: this.allowedFileType,
    fileUploadedFlag: false,
    templateUrl: `templates/global_index_template.xlsx`,
    downloadSpinner: false,
    downloadText: "Download Template",
    fileUploadErrorMessage: "",
  };
  uploadedFile!: any;
  kbFactor = 1e3;
  mbFactor = 1e6;
  gbFactor = 1e9;
  buttonDisabled: boolean = true;
  showDialogLoader: boolean = false;
  excelHeader: any = [
    {
      label: "sku",
      value: "sku",
    },
    {
      label: "sku_detail",
      value: "sku_detail",
    },
    {
      label: "ptc_segment",
      value: "ptc_segment",
    },
    {
      label: "brand",
      value: "brand",
    },
    {
      label: "volume",
      value: "volume",
    },
    {
      label: "maco_hl",
      value: "maco_hl",
    },
    {
      label: "maco_hl_threshold",
      value: "maco_hl_threshold",
    },
    {
      label: "maco_hl_segment",
      value: "maco_hl_segment",
    },
    {
      label: "vilc_hl",
      value: "vilc_hl",
    },
    {
      label: "vilc_index",
      value: "vilc_index",
    },
    {
      label: "financially_viable",
      value: "financially_viable",
    },
    {
      label: "have_new_vilc_hl",
      value: "have_new_value",
    },
    {
      label: "new_vilc_hl",
      value: "new_vilc_hl",
    },
  ];
  validationData: any = {};
  showValidationError: boolean = false;

  constructor(
    private stateService: StateService,
    private httpService: HttpService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["opportunities"]) {
      this.loadData();
    }
  }

  loadData() {
    if (this.opportunities?.length) {
      this.rows = [...this.opportunities];
    }
    this.totalItems = this.rows.length;
    this.currentPage = 1;
    this.prepareForms();
  }

  prepareForms() {
    this.formMap = {};
    this.rows.forEach((r, index) => {
      this.formMap[index] = new FormGroup({
        financially_viable: new FormControl(r.financially_viable),
        have_new_value: new FormControl(r.have_new_value),
        new_vilc_hl: new FormControl(r.new_vilc_hl),
      });
    });
  }

  setViable(row: VILCOpportunity, value: boolean) {
    const index = this.rows.indexOf(row);
    row.financially_viable = value;
    if (!value) {
      row.new_vilc_hl = null;
      row.have_new_value = null;
      this.formMap[index].get("new_vilc_hl")?.setValue(null);
      this.formMap[index].get("have_new_value")?.setValue(null);
    }
    this.formMap[index].get("financially_viable")?.setValue(value);
  }

  startEdit(row: VILCOpportunity) {
    const index = this.rows.indexOf(row);
    row.financially_viable = null;
    row.have_new_value = null;
    row.new_vilc_hl = null;
    this.formMap[index].reset({
      financially_viable: null,
      have_new_value: null,
      new_vilc_hl: null,
    });
  }

  sethave_new_value(row: VILCOpportunity, value: boolean | null) {
    const index = this.rows.indexOf(row);
    row.have_new_value = value;
    if (value === false) {
      row.new_vilc_hl = null;
      this.formMap[index].get("new_vilc_hl")?.setValue(null);
    }
    this.formMap[index].get("have_new_value")?.setValue(value);
  }

  // ...existing code...
  onnew_vilc_hlChange(row: VILCOpportunity, value: any) {
    const index = this.rows.indexOf(row);
    if (index < 0) return;

    const raw =
      typeof value === "string"
        ? value.trim()
        : typeof value === "number"
          ? String(value)
          : (value ?? "");

    const sanitized = raw.replace(/[^0-9.-]/g, "");
    const isIncomplete =
      sanitized === "" ||
      sanitized === "-" ||
      sanitized === "." ||
      sanitized === "-.";

    const numericValue = isIncomplete ? null : Number(sanitized);

    row.new_vilc_hl = numericValue;
    this.formMap[index].get("new_vilc_hl")?.setValue(numericValue);
  }
  // ...existing code...
  trackByIndex(index: number, item: VILCOpportunity) {
    return index;
  }

  get totalPages() {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  get startIndex() {
    return (this.currentPage - 1) * this.pageSize;
  }

  get endIndex() {
    return Math.min(this.startIndex + this.pageSize, this.totalItems);
  }

  get paginatedRows(): VILCOpportunity[] {
    if (this.totalItems === 0) {
      return [];
    }
    if (this.currentPage < 1) {
      this.currentPage = 1;
    } else if (this.currentPage > this.totalPages) {
      this.currentPage = this.totalPages;
    }
    return this.rows.slice(this.startIndex, this.endIndex);
  }

  onPageSizeChange(event: any) {
    this.pageSize = Number(event.target.value);
    this.currentPage = 1;
  }

  prevPage() {
    if (this.currentPage > 1) this.currentPage--;
  }

  nextPage() {
    if (this.currentPage < this.totalPages) this.currentPage++;
  }

  onPageInputChange(event: Event) {
    const input = (event.target as HTMLInputElement).value;
    let page = Number(input);
    if (isNaN(page) || page < 1) {
      page = 1;
    } else if (page > this.totalPages) {
      page = this.totalPages;
    }
    this.currentPage = page;
  }

  openVilcGuideDialog() {
    this.showVilcGuideDialog = true;
  }

  nextStep() {
    if (this.currentStep < 3) {
      this.currentStep++;
    }
  }

  prevStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  finish() {
    this.showVilcGuideDialog = false;
    this.currentStep = 1;
  }

  openModifyDialog() {
    this.showModifyDialog = true;
  }

  parseFileSize(sizeInBytes: any) {
    const factor =
      sizeInBytes > this.gbFactor
        ? this.gbFactor
        : sizeInBytes > this.mbFactor
          ? this.mbFactor
          : this.kbFactor;
    const suffix =
      factor === this.gbFactor
        ? " GB"
        : factor === this.mbFactor
          ? " MB"
          : " KB";
    const size = sizeInBytes / factor;
    return String(parseFloat(size.toFixed(1))) + suffix;
  }

  onDownloadResults() {
    const excelRows = this.rows.map((row) => ({
      ...row,
      financially_viable:
        row.financially_viable === true
          ? "Yes"
          : row.financially_viable === false
            ? "No"
            : row.financially_viable,
      have_new_value:
        row.have_new_value === true
          ? "Yes"
          : row.have_new_value === false
            ? "No"
            : row.have_new_value,
    }));
    this.stateService.exportToExcel(
      this.excelHeader,
      excelRows,
      "vilc_opportunities",
    );
  }

  onFileDrop(event: any) {
    const droppedFiles: FileList = event.file.dataTransfer.files;
    this.uploadedFile = droppedFiles[0];
    this.fileUploadContent["fileName"] = String(this.uploadedFile.name);
    this.fileUploadContent["filesize"] = this.parseFileSize(
      this.uploadedFile.size,
    );
    this.fileUploadContent["loaderFlag"] = true;
    this.buttonDisabled = false;
    this.onFileUploadApiCall();
  }

  onFileBrowse(e: any) {
    if (e?.target?.files?.[0]) {
      this.uploadedFile = e.target.files[0];
      this.fileUploadContent["fileName"] = String(this.uploadedFile.name);
      this.fileUploadContent["filesize"] = this.parseFileSize(
        this.uploadedFile.size,
      );
      this.fileUploadContent["loaderFlag"] = true;
      this.buttonDisabled = false;
      this.onFileUploadApiCall();
    }
  }

  onFileUploadCancel(event: any = "") {
    this.uploadedFile = [];
    this.fileUploadContent["fileName"] = "";
    this.fileUploadContent["filesize"] = "";
    this.fileUploadContent["fileUploadStatus"] = false;
    this.fileUploadContent["loaderFlag"] = false;
    this.fileUploadContent["fileUploadPercent"] = 0;
    this.buttonDisabled = true;
  }

  onFileUploadApiCall() {
    this.fileUploadContent.fileUploadErrorMessage = "";
    if (!this.fileTypeValidation()) {
      return;
    }
    const data = new FormData();
    this.fileUploadContent["fileName"] = String(this.uploadedFile.name);
    this.fileUploadContent["filesize"] = this.parseFileSize(
      this.uploadedFile.size,
    );

    data.append("upload_file", this.uploadedFile, this.uploadedFile.name);

    this.fileUploadContent["loaderFlag"] = true;

    let apiUrl = "";
    apiUrl = `${this.stateService.apiList.experiments.phoExperiments}/${this.expId}/file/dtp_vilc`;

    this.commonFileApiCall(
      apiUrl,
      "postFileMethod",
      data,
      (response: any, params: any) => {
        if (response?.status === "progress") {
          this.fileUploadContent["fileUploadStatus"] = true;
          this.fileUploadContent["fileUploadPercent"] = response.percent;
        } else if (
          response?.task_id ||
          response?.message === "File saved to BLOB"
        ) {
          this.fileUploadContent["loaderFlag"] = false;
          this.fileUploadContent["fileUploadStatus"] = true;
          this.fileUploadContent["fileUploadedFlag"] = true;
          this.fileUploadContent["fileUploadPercent"] = 100;
          this.runValidationAPI("postMethod");
          this.buttonDisabled = false;
        }
      },
    );
  }

  // Function for Common API Call
  commonFileApiCall(
    apiUrl: string,
    method: string,
    params: any,
    callback: (response: any, params: any) => void,
  ) {
    this.httpService[method as keyof HttpService](apiUrl, params).subscribe(
      (response: any) => {
        if (response) {
          // common callback function for response
          callback(response, params);
        }
      },
      (err: any) => {
        if (err.status === 400) {
          this.messageService.add({
            key: "w",
            severity: "warn",
            summary: "Something went wrong!",
            detail: err.error.message,
            sticky: true,
          });
        } else if (err.status !== 401) {
          this.messageService.clear();
          this.messageService.add({
            key: "c",
            severity: "warn",
            summary: err.error.message,
            detail: err.error.traceback,
            sticky: true,
          });
        }
        this.onFileUploadCancel("null");
        this.stateService.removeCalledApi(apiUrl);
      },
    );
  }
  runValidationAPI(method: string) {
    const apiUrl = this.stateService.apiList.experiments.runDTPValidation(
      this.expId,
      "dtp_vilc",
    );

    // Call the API using commonApiCall method
    this.commonApiCall(apiUrl, method, {}, (response: any, params: any) => {
      if (method === "getMethod") {
        this.showValidationError = true;
        this.validationData["vilc"] = JSON.parse(response.result).result[
          "vilc"
        ];
        const hasRedError = Object.values(this.validationData["vilc"])
          .filter((value) => Array.isArray(value)) // only process sections with arrays
          .flat()
          .some((item: any) => item.level === "red");
        this.buttonDisabled = hasRedError;
      } else if (method === "postMethod") {
        this.pollingApiCall(response?.task_id);
      }
    });
  }
  // Function for check the file type validation
  fileTypeValidation() {
    let c = 0;
    this.allowedFileType.map((f: any) => {
      if (this.uploadedFile.type === f) {
        c = 1;
      }
    });
    if (c === 0) {
      this.fileUploadContent["fileUploadErrorMessage"] =
        "Invalid file format. Accepted formats: CSV, XLS, XLSX. Please re-upload the file.";
      return false;
    } else {
      return true;
    }
  }
  onDialogClose() {
    if (this.showModifyDialog) {
      this.showModifyDialog = false;
    }
  }

  editModifyProceed() {
    this.showDialogLoader = true;
    const apiUrl = this.stateService.apiList.experiments.updateVILCForSKU(
      this.expId,
    );
    this.commonApiCall(apiUrl, "postMethod", {}, (response: any) => {
      if (response) {
        this.showDialogLoader = false;
        if (this.showModifyDialog) {
          this.showModifyDialog = false;
        }
        this.onFileUploadCancel();
        this.refreshVilcOpportunities.emit();
      }
    });
  }

  onSimulate() {
    const updatedVilcTablePayloadData = this.rows.map((r) => ({
      sku: r.sku,
      financially_viable: r.financially_viable,
      new_vilc_hl: r.financially_viable ? (r.new_vilc_hl ?? null) : null,
    }));
    this.actionButtonCall.emit(updatedVilcTablePayloadData);
  }

  get isSimulationDisabled(): boolean {
    return !this.rows.every((r) => {
      if (r.financially_viable === null || r.financially_viable === undefined) {
        return false;
      }
      if (r.financially_viable === true) {
        if (r.have_new_value === null || r.have_new_value === undefined) {
          return false;
        }
        if (
          r.have_new_value === true &&
          (r.new_vilc_hl === null || r.new_vilc_hl === undefined)
        ) {
          return false;
        }
      }
      return true;
    });
  }

  // Function for Common API Call
  commonApiCall(
    apiUrl: string,
    method: string,
    params: any,
    callback: (response: any, params: any) => void,
    extraFlag: any = {},
  ) {
    this.httpService[method as keyof HttpService](apiUrl, params).subscribe(
      (response: any) => {
        if (response) {
          // common callback function for response
          response["extra_flag"] = extraFlag;
          callback(response, params);
        }
      },
      (err: any) => {
        if (err.status === 400) {
          this.messageService.add({
            key: "w",
            severity: "warn",
            summary: "Something went wrong!",
            detail: err.error.message,
            sticky: true,
          });
        } else if (err.status !== 401) {
          this.messageService.clear();
          this.messageService.add({
            key: "c",
            severity: "warn",
            summary: err.error.message,
            detail: err.error.traceback,
            sticky: true,
          });
        }
        this.stateService.removeCalledApi(apiUrl);
      },
    );
  }

  // Function for polling(status) api call
  pollingApiCall(taskId: any) {
    const url = `${this.stateService.apiList.experiments.goProcess}${taskId}/status`;

    this.httpService.getMethod(url).subscribe((response) => {
      if (response.status === "SUCCESS") {
        this.runValidationAPI("getMethod");
      } else if (response.status === "FAILURE") {
        this.messageService.add({
          key: "w",
          severity: "warn",
          summary: "Something went wrong!",
          detail: "Task Failed",
          sticky: true,
        });
      } else {
        setTimeout(() => {
          this.pollingApiCall(taskId);
        }, 3000);
      }
    });
  }

  restrictToNumeric(event: KeyboardEvent, currentValue: string = "") {
    const input = event.target as HTMLInputElement | null;
    const value = input?.value ?? currentValue;
    const selectionStart =
      input?.selectionStart !== null && input?.selectionStart !== undefined
        ? input.selectionStart
        : value.length;

    const allowedControlKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
      "Home",
      "End",
    ];
    if (allowedControlKeys.includes(event.key)) {
      return;
    }

    const isDigit = /[0-9]/.test(event.key);
    const isDot = event.key === ".";
    const isMinus = event.key === "-";
    const alreadyHasDot = value.includes(".");
    const alreadyHasMinus = value.includes("-");

    if (isDigit) {
      return;
    }

    if (isDot) {
      if (alreadyHasDot) {
        event.preventDefault();
      }
      return;
    }

    if (isMinus) {
      const selectionEnd = input?.selectionEnd ?? value.length;
      const wholeSelection =
        selectionStart === 0 && selectionEnd === value.length;
      if (alreadyHasMinus && !wholeSelection) {
        event.preventDefault();
        return;
      }
      if (selectionStart !== 0) {
        event.preventDefault();
      }
      return;
    }

    event.preventDefault();
  }
}
